/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { Field } from "formik";
import { InputGroup, Form } from "react-bootstrap";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCSelect from "../ucselect";

/* Styles */
import styles from "./styles.js";
import { expenditureSelect } from "./styles";

const ExpenditureSelector = (props) => {
  const { disabled } = props;

  const theme = useTheme();
  const classes = styles({ theme, disabled });

  const formatDisplayValue = (val) => {
    if (!val) return "";
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <InputGroup className={classes.inputGroupWrapper}>
      <span className={classes.currencyLabel}>$</span>
      <Field name="hotelExpenditure">
        {({ field, form }) => (
          <Form.Control
            type="text"
            className={classes.expenditure}
            inputMode="numeric"
            id="hotelExpenditure"
            name="hotelExpenditure"
            value={formatDisplayValue(field.value)}
            onChange={(e) => {
              const rawValue = e.target.value.replace(/,/g, "");
              if (rawValue === "" || /^\d+$/.test(rawValue)) {
                if (rawValue.length <= 16) {
                  form.setFieldValue("hotelExpenditure", rawValue);
                }
              }
            }}
            onBlur={field.onBlur}
            disabled={disabled}
          />
        )}
      </Field>
      <span className={classes.currencyLabel}>USD</span>
      {/* <Field type="select" name="expenditureCurrency" id="expenditureCurrency">
        {({ form }) => (
          <UCSelect
            isSearchable={false}
            styles={expenditureSelect}
            options={currencyOptions}
            value={form.values.expenditureCurrency}
            getOptionLabel={(data) => <div>{data.label}</div>}
            onChange={(item) => {
              form.setFieldValue('expenditureCurrency', item.value);
              form.setFieldTouched('hotelExpenditure', true);
            }}
            disabled={disabled}
          />
        )}
      </Field> */}
    </InputGroup>
  );
};

export default ExpenditureSelector;
